import { createContext, useContext } from 'react';

import type { MREContextType } from '../types';

/* This context and associated hook are used to manage IMMUTABLE state related to the MRE + terrainEngine instance.

  Note: Mutable state is managed in MREStateContextProvider and useMREState hook.
*/

export const MREContext = createContext<MREContextType>({
  page: null,
  mapContainerRef: { current: null },
  terrainEngine: null,
  setTerrainEngine: () => {},
  versionInfo: null,
  setVersionInfo: () => {},
  track: () => {},
  t: (key) => key
});

export const useMRE = (): MREContextType => {
  const context = useContext(MREContext);
  if (!context) {
    throw new Error('useMRE must be used within the MREContext.Provider');
  }
  return context;
};
